import { fetch } from 'utils/api';

export const getLanguages = () => {
  return fetch({
    url: '/languages',
    method: 'GET'
  });
};
